export default "__VITE_ASSET__DHWdg9F$__"